import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CreateLocationInputDto } from "../../../models/location/dto/create-location.dto";
import { OrganizationLocationDto } from "../../../models/location/dto/location.dto";
import { GET_LOCATIONS_QUERY_KEY } from "./useGetLocations";

export const useCreateLocation = (organizationId:string) => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['createLocation'],
        mutationFn: (dto: CreateLocationInputDto) => client.fetchApi<OrganizationLocationDto, CreateLocationInputDto>({ endpoint: `organizations/${organizationId}/locations`, method: 'POST', body: dto }),
        onSuccess: (data) => {
            queryClient.setQueryData(GET_LOCATIONS_QUERY_KEY(data.organizationId), (old: OrganizationLocationDto[]) => [...old, data]);
        }
    });
};